import 'antd/dist/antd.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import TimeAgo from 'javascript-time-ago'
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './index.css';
import './antStyle.css';
import { sentry } from './config.json'

import es from 'javascript-time-ago/locale/es-MX.json'

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

TimeAgo.addDefaultLocale(es);

Sentry.init({ ...sentry, integrations: [new Integrations.BrowserTracing()] });

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js